import { connect } from 'react-redux'
import { compose, branch, renderNothing } from 'recompose'
import {
  unreadActivityCountSelector,
  activityShowingSelector
} from '../../../store/selectors/activitySelectors'
import { toggleActivity } from '../../../store/actions/activity'
import { anonSelector } from '../../../store/selectors/baseSelectors'

const ActivityIconContainer = compose(
  connect(
    state => ({
      anon: anonSelector(state),
      unread: unreadActivityCountSelector(state) || 0,
      active: activityShowingSelector(state)
    }),
    { toggleActivity }
  ),
  branch(({ anon }) => anon, renderNothing)
)

export default ActivityIconContainer
